import moment from "moment";
import {
  GET_SCIENTIFIC_EVIDENCE,
  SET_PAGE,
  SET_SEARCH,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialScientificEvidence = {
  scientificEvidence: [],
  scientificEvidenceCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

const scientificEvidenceReducer = (
  state = initialScientificEvidence,
  action
) => {
  switch (action.type) {
    case GET_SCIENTIFIC_EVIDENCE:
      return {
        ...state,
        scientificEvidence: action.payload.scientificEvidence.map(
          (evidence) => {
            return {
              ...evidence,
              updatedAtFormatted: moment(evidence.createdAt).format("ll"),
              publishedDateFormatted: moment(evidence.publishedDate).format(
                "ll"
              ),
            };
          }
        ),
        scientificEvidenceCount: action.payload.totalCount,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };

    default:
      return state;
  }
};

export default scientificEvidenceReducer;
